export default function FooterCta({ onStart, onSolo }: { onStart: () => void; onSolo: () => void }) {
  return (
    <section className="bg-navy py-14 md:py-18">
      <div className="mktg-container">
        <p className="mono-label text-golden mb-4">End of document</p>
        <h2 className="hl hl-fit text-[clamp(1.4rem,5vw,3.6rem)] text-stone mb-4">
          See it on your own work
        </h2>
        <p className="descriptor text-lg text-stone/70 max-w-xl mb-8">
          Run the whole workshop by yourself in about 25 minutes, free, and decide
          afterwards whether to bring the team.
        </p>
        <div className="flex flex-wrap gap-3">
          <button onClick={onSolo} className="btn btn-amber">
            Start a solo session
          </button>
          <button onClick={onStart} className="btn btn-on-dark">
            Run it with your team
          </button>
        </div>
      </div>
    </section>
  )
}
